import type { UseLiveTranscriptionResult } from "@transcription/use-live-transcription";
import { createContext, useContext } from "react";

export const TranscriptionContext =
  createContext<UseLiveTranscriptionResult | null>(null);

export const useTranscription = (): UseLiveTranscriptionResult => {
  const ctx = useContext(TranscriptionContext);
  if (!ctx)
    throw new Error(
      "useTranscription must be used within TranscriptionProvider",
    );
  return ctx;
};
